"use client";
import { inter } from "@/components/ui/fonts";
import { FiEye } from "react-icons/fi";
import React, { useState } from 'react';
import { FiEyeOff } from "react-icons/fi";
interface PasswordInputProp {
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}
export default function PasswordInput({value, onChange}: PasswordInputProp) {
  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordShow = () => {
    setShowPassword((prev) => !prev);
  }
  
  return (
    <div className="flex items-center justify-center w-full h-full relative mt-2">
      <input value={value} onChange={onChange} type={showPassword ? 'text': 'password'} placeholder="Enter your password" className={`${inter.className} border border-gray-200 text-[14px] w-full pl-3 pr-10 py-[8px] focus:border-[#007F61] placeholder-slate-400 rounded-md focus:outline-none focus:ring-[3px] focus:ring-[#6faa9b] focus:ring-opacity-50`} />
      <div className="absolute right-5 cursor-pointer" onClick={togglePasswordShow}>
        {
          showPassword ? <FiEyeOff className="text-slate-500"/> :  <FiEye className="text-slate-500" /> 
        }
      </div>
      
    </div>
  )
}